<div *ngIf="loading" class="loading-screen-wrapper">
    <div class="logo loading-screen-icon" align="center">
        <img src="/assets/loader/NovaeLooading-{{source}}.gif">
        <span class="texto-loader" *ngIf="showMessage" innerHTML="{{'LOADING_SCREEN.fulltext' | translate:'{textos2:\'' + textos2 + '\', textos3:\'' + textos3 + '\', textos:\'' + textos + '\'}'}}">
      Estamos {{textos2}} <br>
      <strong> tu {{textos3}}  {{textos}}</strong>
    </span>
    </div>
</div>